import { FILENAME_SAFE_DATETIME_FORMAT, useCurrentTime } from './useCurrentTime';

export const useExportFileName = () => {
  const { getCurrentTime } = useCurrentTime();

  const getExportFileName = ({
    documentName,
    patientDemographicString,
  }: {
    documentName?: string | null;
    patientDemographicString?: string | null;
  }) => {
    return `${documentName ?? ''} ${patientDemographicString ?? ''} ${getCurrentTime(FILENAME_SAFE_DATETIME_FORMAT)}`.replace(
      /[/\n\\]/g,
      ''
    );
  };

  return {
    getExportFileName,
  };
};
